import React, { useEffect } from "react";

export default function Starfield({ inApp = false, isMobile = false }) {
  useEffect(() => {
    const el = document.getElementById("starfield");
    if (!el) return undefined;

    el.classList.toggle("starfield--in-app", inApp);
    const count = inApp ? (isMobile ? 40 : 80) : 200;

    for (let i = 0; i < count; i++) {
      const s = document.createElement("div");
      const size = Math.random() < 0.85 ? Math.random() * 1.5 + 0.5 : Math.random() * 3 + 1.5;
      s.className = "star";
      s.style.cssText = `
        left:${Math.random() * 100}%;top:${Math.random() * 100}%;
        width:${size}px;height:${size}px;
        --dur:${2 + Math.random() * 4}s;--del:${Math.random() * 5}s;
        --base-op:${0.1 + Math.random() * 0.4};
        opacity:${0.1 + Math.random() * 0.4};
      `;
      el.appendChild(s);
    }

    return () => {
      el.innerHTML = "";
      el.classList.remove("starfield--in-app", "starfield--paused");
    };
  }, [inApp, isMobile]);

  return null;
}
